module.exports = __webpack_public_path__ + "img/g5.b056a450.jpg";